import React from 'react'
import PropTypes from 'prop-types'
import { Item, Label, Content } from './styles'

export default function DescItemInfo({ label, children }) {
  return (
    <Item>
      <Label>{label}</Label>
      <Content>
        {children}
      </Content>
    </Item>
  )
}

DescItemInfo.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
}

DescItemInfo.defaultProps = {
  children: null,
}
